import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PersonIcon from '@material-ui/icons/Person';
import GroupIcon from '@material-ui/icons/Group';
import ClearIcon from '@material-ui/icons/Clear';
import Dialog from '@material-ui/core/Dialog';

import InsideOrgInvite from './InsideOrgInvite';
import OutsideOrgInvite from './OutsideOrgInvite';
import MultipleUsers from './MultipleUsers';
import StyledButton from '../../../../common/models/Button';
import {
  isValid,
  isValidPhoneNumber,
  isValidEmail,
} from '../../../../common/helperFunctions/helper';
import {
  verifyUserInvite,
  sendEmailInvite,
} from '../../../../../containers/actions/inviteUsers';
import {
  getCollaboratorRole,
  getEcosystemCollaborators,
} from '../../../../../containers/actions/ecosystemActions';
import InvitationSent from '../../../../common/InvitationSent';

// Import Styles
import { styles } from './inviteUserStyles';
import {
  associateCMOsRoles,
  associateWarehouseRoles,
} from '../../../../../utils/config';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Grid
      role='tabpanel'
      hidden={value !== index}
      id={`select-invite-${index}`}
      aria-labelledby={`select-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </Grid>
  );
}

class InviteUsers extends Component {
  state = {
    inviteSent: false,
    multiUsers: false,
    usersExceeded: false,
    activeTab: 0,
    numberRequired: false,
    collabRoles: [],
    collaboratorTypes: [],
    errors: {},
    usersList: [],
    userEmail: [],
    countryCode: 'in',
    dialCode: '91',
    associateWarehouseAccess: 'select',
    userData: {
      collaboratorTypeName: '',
      collaboratorRoleName: '',
      collaboratorRoleId: '',
      email: '',
      fullName: '',
      phoneNumber: '',
      twoStepAuthentication: false,
      editPhoneNumber: false,
      azureADSignIn: false,
      organizationName: '',
      userOrgType: '',
      selectedCMOs: [],
      selectedWarehouses: [],
    },
    buttonsDisabled: {
      addToList: false,
      sendInvite: false,
      sendInviteToAll: false,
      switchTab: false,
    },
  };

  componentDidMount() {
    let data = {
      collaboratorTypeId: this.props.collabType === 'Pharma Co' ? 1 : 2,
      collaboratorTypeName: localStorage.getItem('collabType'),
    };
    this.props.getCollaboratorRole(data);
    this.props.getEcosystemCollaborators();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.collabRoles !== this.props.collabRoles &&
      this.props.collabRoles.status === true
    ) {
      this.setState({
        collabRoles: this.props.collabRoles.data,
      });
    }
    if (
      prevProps.collabType !== this.props.collabType &&
      this.props.collabType.status === true
    ) {
      this.setState({
        collaboratorTypes: this.props.collabType.data,
      });
    }
    if (
      prevProps.userInvite !== this.props.userInvite &&
      //if true push user into list
      this.props.userInvite.status === true
    ) {
      const { userData, activeTab } = this.state;
      // View is showing can not edit phone number so negate the value of editPhoneNumber
      userData.editPhoneNumber = !userData.editPhoneNumber;
      if (activeTab === 0) {
        delete userData.organizationName;
        this.setState((prevState) => ({
          usersList: [...prevState.usersList, userData],
          buttonsDisabled: {
            ...this.state.buttonsDisabled,
            addToList: false,
            switchTab: false,
          },
        }));
        this.setEmptyUserObject();
      } else {
        this.setState((prevState) => ({
          usersList: [...prevState.usersList, userData],
          buttonsDisabled: {
            ...this.state.buttonsDisabled,
            addToList: false,
            switchTab: false,
          },
        }));
        this.setEmptyUserObject();
      }
    }
    if (
      prevProps.userInvite !== this.props.userInvite &&
      //status false show errors
      this.props.userInvite.status === false
    ) {
      this.setState({
        errors: this.props.userInvite.errorDescription,
        buttonsDisabled: {
          addToList: false,
          sendInvite: false,
          sendInviteToAll: false,
          switchTab: false,
        },
      });
    }
    if (
      prevProps.emailInvite !== this.props.emailInvite &&
      //status true to show dialog box
      this.props.emailInvite.status === true
    ) {
      this.setState((prevState) => ({
        inviteSent: true,
        buttonsDisabled: {
          ...prevState.buttonsDisabled,
          sendInvite: false,
          switchTab: false,
          sendInviteToAll: false,
        },
      }));
    }
  }

  changeUserInviteMode = () => {
    this.setState({
      multiUsers: !this.state.multiUsers,
    });
    this.setEmptyUserObject();
  };

  handleCloseInviteSentDialog = () => {
    this.props.closeInvite();
  };

  handleChange = (event, value) => {
    this.setState({
      activeTab: value,
    });
    this.setEmptyUserObject();
  };

  handleChangeOrganization = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      userData: {
        ...prevState.userData,
        [name]: value,
      },
      errors: {},
    }));
  };

  //user details handles
  changePhoneNumber = (phoneNumber, country) => {
    this.setState((prevState) => ({
      userData: {
        ...prevState.userData,
        phoneNumber: phoneNumber,
      },
      country: country.countryCode,
      dialCode: country.dialCode,
      errors: {},
    }));
  };

  handleChangeEmailandName = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      userData: {
        ...prevState.userData,
        [name]: value,
      },
      errors: {},
    }));
  };

  handleChangeCollaborator = (event) => {
    // value is collaboratorRoleId
    const { name, value } = event.target;

    if (this.state.activeTab === 1) {
      this.state.collaboratorTypes.forEach((item) => {
        if (item.collaboratorTypeId === value) {
          this.setState((prevState) => ({
            userData: {
              ...prevState.userData,
              [name]: value,
              collaboratorTypeName: item.collaboratorTypeName,
              selectedCMOs: [],
              selectedWarehouses: [],
            },
            errors: {},
          }));
        }
      });
    } else {
      this.state.collabRoles.forEach((item) => {
        if (item.collaboratorRoleId === value) {
          this.setState((prevState) => ({
            userData: {
              ...prevState.userData,
              [name]: value,
              collaboratorRoleName: item.collaboratorRoleName,
              selectedCMOs: [],
              selectedWarehouses: [],
            },
            errors: {},
          }));
        }
      });
    }
  };

  handleChangeOptions = (event) => {
    const { name, checked } = event.target;
    this.setState((prevState) => ({
      userData: {
        ...prevState.userData,
        [name]: checked,
      },
      errors: {},
    }));
  };

  handleChangeWarehouseOrCMOList = (name, val) => {
    // If setting selectedCMOs, map to include vendorName if present
    // if (name === 'selectedCMOs') {
    //   const mappedVal = val.map(item => ({
    //     ...item,
    //     vendorName: item.vendorName || '',
    //   }));
    //   this.setState((prevState) => ({
    //     userData: {
    //       ...prevState.userData,
    //       [name]: mappedVal,
    //     },
    //     errors: {},
    //   }));
    // } else {
      this.setState((prevState) => ({
        userData: {
          ...prevState.userData,
          [name]: val,
        },
        errors: {},
      }));
    // }
  };

  handleChangeWarehouseAccess = (val) => {
    this.setState((prevState) => ({
      associateWarehouseAccess: val,
    }));
  };

  sendAnotherInvite = () => {
    this.setState({
      inviteSent: false,
      usersList: [],
    });
    this.setEmptyUserObject();
  };
  // Use this to clear user data
  setEmptyUserObject = () => {
    this.setState({
      errors: {},
      // collabRoles: [],
      userData: {
        collaboratorTypeName: '',
        collaboratorTypeId: '',
        collaboratorRoleName: '',
        collaboratorRoleId: '',
        email: '',
        fullName: '',
        organizationName: '',
        phoneNumber: `${this.state.dialCode}`,
        twoStepAuthentication: false,
        editPhoneNumber: false,
        azureADSignIn: false,
        userOrgType: '',
        selectedCMOs: [],
        selectedWarehouses: [],
      },
    });
  };

  //validate user details
  validate = () => {
    const {
      activeTab,
      multiUsers,
      usersList,
      dialCode,
      associateWarehouseAccess,
    } = this.state;
    const {
      organizationName,
      email,
      fullName,
      phoneNumber,
      collaboratorRoleName,
      collaboratorTypeName,
      editPhoneNumber,
      collaboratorRoleId,
      selectedCMOs,
      selectedWarehouses,
    } = this.state.userData;
    let errors = {};
    let isError = false;
    let emailExits = usersList.filter((ele) => ele.email === email);

    if (activeTab === 0 && !isValid(collaboratorRoleName)) {
      isError = true;
      errors.collaboratorRoleName = 'Please Select Collaborator Role';
    } else if (activeTab === 1 && collaboratorTypeName === '') {
      isError = true;
      errors.collaboratorTypeName = 'Please Select Collaborator Type';
    } else if (!isValid(email)) {
      isError = true;
      errors.email = 'Please enter email';
    } else if (!isValidEmail(email)) {
      isError = true;
      errors.email = 'Please enter valid email';
    } else if (multiUsers === true && emailExits.length > 0) {
      isError = true;
      errors.email = 'Email is already added to the list';
    } else if (!(fullName.length > 0)) {
      isError = true;
      errors.fullName = 'Please enter the name';
    } else if (
      // Keep in mind that the value shown is opposite of what makes sense
      editPhoneNumber === true &&
      !isValidPhoneNumber(phoneNumber, dialCode)
    ) {
      isError = true;
      errors.phoneNumber =
        'Please enter phone number when edit option is disabled';
    } else if (activeTab === 1 && !isValid(organizationName)) {
      isError = true;
      errors.organizationName = 'Please select Organization';
    } else if (
      activeTab === 0 &&
      associateCMOsRoles.includes(collaboratorRoleId) &&
      selectedCMOs.length === 0
    ) {
      isError = true;
      errors.associateCMOs = 'Please select Associate CMOs';
    } else if (
      activeTab === 0 &&
      associateWarehouseAccess === 'select' &&
      associateWarehouseRoles.includes(collaboratorRoleId) &&
      selectedWarehouses.length === 0
    ) {
      isError = true;
      errors.associateWarehouse = 'Please select Associate warehouses';
    }
    this.setState({
      errors,
    });
    return isError;
  };

  // Remove a user from list
  removeUser = (email) => {
    const { usersList } = this.state;
    let newList = usersList.filter((user) => user.email !== email);
    this.setState({ usersList: newList, usersExceeded: false });
  };

  inviteSingleUser = (event) => {
    event.preventDefault();
    let isError = this.validate();
    if (!isError) {
      // form request object
      const { activeTab, dialCode } = this.state;
      const {
        email,
        fullName,
        phoneNumber,
        organizationName,
        collaboratorRoleName,
        collaboratorRoleId,
        collaboratorTypeName,
        collaboratorTypeId,
        twoStepAuthentication,
        azureADSignIn,
        editPhoneNumber,
        selectedCMOs,
        selectedWarehouses,
      } = this.state.userData;

      const data = {
        email,
        fullName,
        collaboratorTypeName:
          activeTab === 0
            ? localStorage.getItem('collabType')
            : collaboratorTypeName,
        // if collab type IDs change get these values from APIs
        collaboratorTypeId: activeTab === 0 ? 1 : collaboratorTypeId,
        collaboratorRoleName: activeTab === 0 ? collaboratorRoleName : 'fluke',
        collaboratorRoleId: activeTab === 0 ? collaboratorRoleId : 120,
        phoneNumber:
          isValidPhoneNumber(phoneNumber, dialCode) === true
            ? `+${phoneNumber}`
            : '',
        twoStepAuthentication,
        azureADSignIn,
        // View is showing can not edit so negate the value here
        editPhoneNumber: !editPhoneNumber,
        warehouseDetailsList:
          activeTab === 0
            ? associateWarehouseRoles.includes(collaboratorRoleId)
              ? selectedWarehouses
              : []
            : [],
        cmoOrgList:
          activeTab === 0
            ? associateCMOsRoles.includes(collaboratorRoleId)
              ? selectedCMOs
              : []
            : [],
      };
      let invite = activeTab === 0 ? data : { ...data, organizationName };
      // call send invite action with users array
      this.sendInvitation({ users: [invite] });
      this.setState((prevState) => ({
        buttonsDisabled: {
          ...prevState.buttonsDisabled,
          sendInvite: true,
          switchTab: true,
        },
      }));
    }
  };

  addUserToList = () => {
    const { activeTab, usersList, dialCode } = this.state;
    if (usersList.length < 7) {
      let isError = this.validate();
      if (!isError) {
        const {
          organizationName,
          email,
          fullName,
          phoneNumber,
          collaboratorRoleName,
          collaboratorTypeName,
          collaboratorRoleId,
          collaboratorTypeId,
          twoStepAuthentication,
          azureADSignIn,
          editPhoneNumber,
          selectedWarehouses,
          selectedCMOs,
        } = this.state.userData;

        const data = {
          email,
          fullName,
          collaboratorTypeName:
            activeTab === 0
              ? localStorage.getItem('collabType')
              : collaboratorTypeName,
          collaboratorTypeId: activeTab === 0 ? 1 : collaboratorTypeId,
          collaboratorRoleName:
            activeTab === 0 ? collaboratorRoleName : 'Admin',
          collaboratorRoleId: activeTab === 0 ? collaboratorRoleId : 120,
          phoneNumber:
            isValidPhoneNumber(phoneNumber, dialCode) === true
              ? `+${phoneNumber}`
              : '',
          twoStepAuthentication,
          azureADSignIn,
          editPhoneNumber: !editPhoneNumber,
        };

        let invite = activeTab === 0 ? data : { ...data, organizationName };
        // Verify Users
        this.props.verifyUserInvite(invite);

        this.setState((prevState) => ({
          userData: {
            ...prevState.userData,
            phoneNumber:
              isValidPhoneNumber(phoneNumber, dialCode) === true
                ? `+${phoneNumber}`
                : '',
            userOrgType:
              activeTab === 0 ? 'Inside Organization' : 'Outside Organization',
            collaboratorTypeName:
              activeTab === 0
                ? localStorage.getItem('collabType')
                : collaboratorTypeName,
            collaboratorTypeId: activeTab === 0 ? 1 : collaboratorTypeId,
            collaboratorRoleName:
              activeTab === 0 ? collaboratorRoleName : 'Admin',
            collaboratorRoleId: activeTab === 0 ? collaboratorRoleId : 120,
            warehouseDetailsList:
              activeTab === 0
                ? associateWarehouseRoles.includes(collaboratorRoleId)
                  ? selectedWarehouses
                  : []
                : [],
            cmoOrgList:
              activeTab === 0
                ? associateCMOsRoles.includes(collaboratorRoleId)
                  ? selectedCMOs
                  : []
                : [],
          },
          buttonsDisabled: {
            ...prevState.buttonsDisabled,
            addToList: true,
            switchTab: true,
          },
        }));
      }
    } else {
      this.setState({ usersExceeded: true });
    }
  };

  sendInvitation = (data) => {
    this.props.sendEmailInvite(data);
  };

  sendInvitationToAll = () => {
    this.setState((prevState) => ({
      buttonsDisabled: {
        ...prevState.buttonsDisabled,
        sendInviteToAll: true,
        switchTab: true,
      },
      usersExceeded: false,
    }));
    this.sendInvitation({ users: this.state.usersList });
  };

  render() {
    const { classes, closeInvite } = this.props;
    const collabType = localStorage.getItem('collabType');
    const {
      inviteSent,
      multiUsers,
      activeTab,
      usersList,
      collabRoles,
      collaboratorTypes,
      errors,
      buttonsDisabled,
      associateWarehouseAccess,
    } = this.state;
    const {
      organizationName,
      email,
      fullName,
      phoneNumber,
      collaboratorRoleId,
      twoStepAuthentication,
      editPhoneNumber,
      azureADSignIn,
      collaboratorTypeId,
      selectedCMOs,
      selectedWarehouses,
    } = this.state.userData;
    return (
      <div>
        <Grid container justify='center'>
          <Grid item xs={12} className={classes.headerGrid}>
            <Grid
              container
              direction='row'
              alignItems='center'
              style={{ padding: '1.5rem 1rem 2rem 1rem' }}
            >
              <Grid
                item
                xs={12}
                sm={4}
                onClick={this.changeUserInviteMode}
                className={classes.userInvite}
              >
                {multiUsers === true ? (
                  <React.Fragment>
                    <PersonIcon fontSize='large' />
                    <Typography
                      color='primary'
                      variant='body2'
                      className={classes.inviteText}
                    >
                      Invite One Person at a Time
                    </Typography>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <GroupIcon fontSize='large' />
                    <Typography
                      color='primary'
                      variant='body2'
                      className={classes.inviteText}
                    >
                      Invite More than one Person to Join
                    </Typography>
                  </React.Fragment>
                )}
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant='h4' className={classes.join}>
                  Invite to Join Ecosystem
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4} className={classes.alignEnd}>
                <Typography
                  variant='body2'
                  className={classes.closeText}
                  onClick={closeInvite}
                >
                  Cancel <ClearIcon fontSize='large' />
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={multiUsers === true ? 6 : 12}>
            <Paper className={classes.root}>
              <Tabs
                value={activeTab}
                onChange={this.handleChange}
                centered
                classes={{
                  indicator: classes.indicator,
                  flexContainer: classes.tabsOutline,
                }}
              >
                <Tab
                  classes={{ selected: classes.selected }}
                  disabled={buttonsDisabled.switchTab}
                  disableRipple
                  disableFocusRipple
                  label={
                    <Typography variant='body2' className={classes.tabText}>
                      Inside Organization
                    </Typography>
                  }
                />
                {collabType === 'Pharma Co' && (
                  <Tab
                    classes={{ selected: classes.selected }}
                    disabled={buttonsDisabled.switchTab}
                    disableRipple
                    disableFocusRipple
                    label={
                      <Typography variant='body2' className={classes.tabText}>
                        Outside Organization
                      </Typography>
                    }
                  />
                )}
                {collabType === 'SMO' && (
                  <Tab
                    classes={{ selected: classes.selected }}
                    disabled={buttonsDisabled.switchTab}
                    disableRipple
                    disableFocusRipple
                    label={
                      <Typography variant='body2' className={classes.tabText}>
                        Outside Organization
                      </Typography>
                    }
                  />
                )}
              </Tabs>
            </Paper>
            <Grid container className={classes.setBorder}>
              <TabPanel value={activeTab} index={0}>
                <InsideOrgInvite
                  inviteSent={inviteSent}
                  multiUsers={multiUsers}
                  collabRoles={collabRoles}
                  collaboratorRoleId={collaboratorRoleId}
                  email={email}
                  fullName={fullName}
                  phoneNumber={phoneNumber}
                  selectedCMOs={selectedCMOs}
                  selectedWarehouses={selectedWarehouses}
                  changePhoneNumber={this.changePhoneNumber}
                  handleChangeEmailandName={this.handleChangeEmailandName}
                  twoStepAuthentication={twoStepAuthentication}
                  editPhoneNumber={editPhoneNumber}
                  azureADSignIn={azureADSignIn}
                  errors={errors}
                  handleClose={this.handleClose}
                  sendAnotherInvite={this.sendAnotherInvite}
                  handleChangeCollaborator={this.handleChangeCollaborator}
                  handleChangeOptions={this.handleChangeOptions}
                  handleChangeWarehouseOrCMOList={
                    this.handleChangeWarehouseOrCMOList
                  }
                  associateWarehouseAccess={associateWarehouseAccess}
                  handleChangeWarehouseAccess={this.handleChangeWarehouseAccess}
                />
              </TabPanel>
              {collabType === 'Pharma Co' && (
                <TabPanel value={activeTab} index={1}>
                  <OutsideOrgInvite
                    inviteSent={inviteSent}
                    multiUsers={multiUsers}
                    collabRoles={collabRoles}
                    collaboratorTypes={collaboratorTypes}
                    collaboratorTypeId={collaboratorTypeId}
                    organizationName={organizationName}
                    email={email}
                    fullName={fullName}
                    phoneNumber={phoneNumber}
                    twoStepAuthentication={twoStepAuthentication}
                    editPhoneNumber={editPhoneNumber}
                    azureADSignIn={azureADSignIn}
                    changePhoneNumber={this.changePhoneNumber}
                    handleChangeEmailandName={this.handleChangeEmailandName}
                    handleChange={this.handleChangeOrganization}
                    errors={errors}
                    handleClose={this.handleClose}
                    sendAnotherInvite={this.sendAnotherInvite}
                    handleChangeCollaborator={this.handleChangeCollaborator}
                    handleChangeOptions={this.handleChangeOptions}
                  />
                </TabPanel>
              )}
              {collabType === 'SMO' && (
                <TabPanel value={activeTab} index={1}>
                  <OutsideOrgInvite
                    inviteSent={inviteSent}
                    multiUsers={multiUsers}
                    collabRoles={collabRoles}
                    collaboratorTypes={collaboratorTypes}
                    collaboratorTypeId={collaboratorTypeId}
                    organizationName={organizationName}
                    email={email}
                    fullName={fullName}
                    phoneNumber={phoneNumber}
                    twoStepAuthentication={twoStepAuthentication}
                    editPhoneNumber={editPhoneNumber}
                    azureADSignIn={azureADSignIn}
                    changePhoneNumber={this.changePhoneNumber}
                    handleChangeEmailandName={this.handleChangeEmailandName}
                    handleChange={this.handleChangeOrganization}
                    errors={errors}
                    handleClose={this.handleClose}
                    sendAnotherInvite={this.sendAnotherInvite}
                    handleChangeCollaborator={this.handleChangeCollaborator}
                    handleChangeOptions={this.handleChangeOptions}
                  />
                </TabPanel>
              )}
              {multiUsers && (
                <Grid container justify='center'>
                  {this.state.usersExceeded && (
                    <Grid item xs={12} sm={10} md={9}>
                      <Typography
                        variant='h6'
                        style={{
                          border: '1px solid #FF0000',
                          backgroundColor: '#FFF0F0',
                          opacity: '1',
                          textAlign: 'center',
                          padding: '0.8rem',
                          fontSize: '0.75rem',
                        }}
                      >
                        You can not add more than 7 users at a time.
                      </Typography>
                    </Grid>
                  )}
                  {this.state.numberRequired && (
                    <Grid item xs={12} sm={10} md={9}>
                      <Typography
                        variant='h6'
                        style={{
                          border: '1px solid #FF0000',
                          backgroundColor: '#FFF0F0',
                          opacity: '1',
                          textAlign: 'center',
                          padding: '0.8rem',
                          fontSize: '0.69rem',
                        }}
                      >
                        You need to add mobile number compulsorily.
                      </Typography>
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={12}
                    sm={8}
                    md={4}
                    lg={6}
                    style={{
                      textAlign: 'center',
                    }}
                  >
                    <br />
                    <br />
                    <StyledButton
                      type='submit'
                      variant='contained'
                      color='primary'
                      size='medium'
                      onClick={this.addUserToList}
                      disabled={buttonsDisabled.addToList}
                    >
                      Add to List
                    </StyledButton>
                    <br />
                    <br />
                  </Grid>
                </Grid>
              )}
              {!multiUsers && (
                <Grid container justify='center'>
                  <Grid
                    item
                    xs={12}
                    sm={8}
                    md={4}
                    lg={6}
                    style={{
                      textAlign: 'center',
                    }}
                  >
                    <br />
                    <br />
                    <StyledButton
                      type='submit'
                      variant='contained'
                      color='primary'
                      size='medium'
                      onClick={this.inviteSingleUser}
                      disabled={buttonsDisabled.sendInvite}
                    >
                      Send Invitation
                    </StyledButton>
                    <br />
                    <br />
                    <br />
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
          {multiUsers && (
            <Grid item xs={10} md={6}>
              <Paper className={`${classes.root} ${classes.paperHidden}`} />
              <Grid className={classes.inviteList}>
                <Typography
                  variant='h5'
                  style={{ fontWeight: '500' }}
                  className={classes.textPadding}
                >
                  Invitation List
                </Typography>
                <Typography variant='body2' className={classes.textPadding}>
                  The list of new people you are about to invite is below. You
                  can modify permissions later as well using the manage users
                </Typography>
                <MultipleUsers
                  usersList={usersList}
                  removeUser={this.removeUser}
                  sendInvitationToAll={this.sendInvitationToAll}
                  disableInvite={buttonsDisabled.sendInviteToAll}
                />
              </Grid>
            </Grid>
          )}
        </Grid>
        {/**Open dialog when an invite is sent */}
        <Dialog open={inviteSent} onClose={this.handleCloseInviteSentDialog}>
          <InvitationSent
            handleClose={this.handleCloseInviteSentDialog}
            sendAnotherInvite={this.sendAnotherInvite}
            email={email}
            multiUsers={multiUsers}
            usersList={usersList}
          />
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userInvite: state.usersInvitation.userInvite,
  collabRoles: state.ecosystems.collaboratorRole,
  collabType: state.ecosystems.collaboratorType,
  emailInvite: state.usersInvitation.emailInvite,
});

export default withStyles(styles)(
  connect(mapStateToProps, {
    verifyUserInvite,
    getCollaboratorRole,
    sendEmailInvite,
    getEcosystemCollaborators,
  })(InviteUsers)
);
